<template>
  <div class="dy_content">
    <div class="search_out">
      <el-popover placement="bottom" width="460" v-model="searchVisible" trigger="manual">
        <div class="history">
          <div class="history_head">
            <div>搜索历史</div>
            <div class="btn" @click="removeHistory"><i class="el-icon-delete"></i>清除</div>
          </div>
          <div class="history_note" v-for="(note, index) of searchHistory" :key="index"
            @click="setSearch(note)">{{note}}</div>
        </div>
        <div class="search" slot="reference">
          <el-input v-model="search" placeholder="请输入主播的名称或者ID" @focus="searchVisible = true"
            @blur="searchVisible = false"></el-input>
          <button @click="searchBtn"><img src="../../../assets/search.png" alt="" />搜索</button>
        </div>
      </el-popover>
    </div>
    <div class="condition">
      <div class="item">
        <span class="des">营销目标</span>
        <el-radio-group v-model="marketing_target" @change="changeMarketingTarget">
          <el-radio v-for="item of queryInfo.marketing_target" :key="item.value" :label="item.value">
            {{item.key}}</el-radio>
        </el-radio-group>
      </div>
      <div class="item">
        <span class="des">内容类型</span>
        <div class="single">
          <div :class="open ? 'options_open' : 'options_close'" class="options">
            <el-checkbox class="pop2" @change="handleCheckboxLevel('内容类型', $event, '不限')"
              v-model="contentIsNoLimit">不限</el-checkbox>
            <template v-for="(item, index) in filterOption.content">
              <el-popover v-if="item.children.length" :class="item.childrenChecked.length ? item.childrenChecked.length === item.children.length ? 'pop2' : 'pop3' : 'pop2'"
                :key="index" placement="bottom" trigger="hover">
                <div class="sub_list">
                  <template v-if="item.children.length">
                    <el-checkbox class="sub_item" v-for="(sebItem,subIndex) of item.children"
                    v-model="sebItem.check"
                    :key="subIndex"
                    @change="handleCheckboxLevel('内容类型', $event, index, subIndex)">{{sebItem.name}}</el-checkbox>
                  </template>
                  <span v-else>无</span>
                </div>
                <div slot="reference">
                  <el-checkbox @change="handleCheckboxLevel('内容类型', $event, index)"
                    v-model="item.check">{{item.name}}</el-checkbox>
                </div>
              </el-popover>
              <el-checkbox v-else class="my-checked" :key="index" @change="handleCheckboxLevel('内容类型', $event, index)"
                    v-model="item.check">{{item.name}}</el-checkbox>
            </template>
          </div>
          <div class="open_close" @click="open = !open">
            {{ open ? "收起" : "展开" }}
            <i :class="open ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          </div>
        </div>
      </div>
      <div class="item">
        <span class="des">达人信息</span>
        <div class="options">
          <el-popover class="info_option" placement="bottom" trigger="click"
            v-for="(item, key) of infoOptionText" :key="key" v-model="item.visible">
            <div v-if="['粉丝数量', '达人报价'].includes(item.name)" class="fans_price">
              <div v-for="(option) of item.options" :key="option.name" class="son_option"
                @click="choice(option, item)">
                {{ option.label }}
              </div>
              <div class="to_input">
                <el-input v-model="item.start" placeholder="0"></el-input>
                <div class="short_line"></div>
                <el-input v-model="item.end" placeholder="50000000"></el-input>
              </div>
              <div class="double_btn">
                <button class="btn_1" @click="resetDes('infoOptionText', key)">重置</button>
                <button class="btn_2" @click="desConfirm(item)">确定</button>
              </div>
            </div>
            <div class="area" v-if="(item.name === '所在地域')">
              <el-cascader :options="item.options" :props="{ multiple: true }" v-model="areachose"
                collapse-tags  @change="changeArea"></el-cascader>
            </div>
            <div class="sex" v-if="item.name === '达人性别'">
              <div class="sex_item" v-for="option of item.options" :key="option.name"
                @click="desConfirm(item, option)">
                {{option.value}}</div>
            </div>
            <div slot="reference" class="option_text">
              {{ item.value }} <i class="el-icon-arrow-down"></i>
            </div>
          </el-popover>
          <el-checkbox style="margin-left:25px" v-model="query.settlement_type" @change="switchChecked($event, {name: '按一口价转换+转化效果', key: 'settlement_type'})" :disabled='inSalesGroup'>
            按一口价转换+转化效果
            <el-tooltip effect="dark" content="按激活数量(暂不支持短视频)：预估收益=底价+转化数量*转化单价，您无需设置报价。 按付费分佣：预估收益=底价+用户有效付费金额*分佣比例，您无需设置报价。" placement="bottom">
              <img src="../../../assets/question.png" class="question" alt="">
            </el-tooltip>
          </el-checkbox>

        </div>
      </div>
      <div class="item">
        <span class="des">受众画像</span>
        <div class="options">
          <el-popover class="info_option" placement="bottom" trigger="click" v-model="visible_fans">
            <div class="fans_img_2">
              <div class="box">
                <div class="name_1">粉丝年龄</div>
                <el-select v-model="fans.fans_age_rate_most" multiple collapse-tags placeholder="请选择">
                  <el-option v-for="item in ages" :key="item.label" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="box">
                <div class="name_1">粉丝性别</div>
                <el-select v-model="fans.gender" placeholder="请选择">
                  <el-option v-for="item in genders" :key="item.label" :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="box">
                <div class="name_1">粉丝设备品牌</div>
                <el-select v-model="fans.fans_system_rate_most" multiple collapse-tags placeholder="请选择">
                  <el-option v-for="item in systems" :key="item.label" :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="box">
                <div class="name_1">粉丝地域</div>
                <el-select v-model="fans.fans_city_level_most" multiple collapse-tags placeholder="请选择">
                  <el-option v-for="item in cities" :key="item.label" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="double_btn">
                <button class="btn_1" @click="resetSingle('fans')">重置</button>
                <button class="btn_3" @click="visible_fans = false">取消</button>
                <button class="btn_2" @click="confirm('fans')">确定</button>
              </div>
            </div>
            <div slot="reference" class="option_text">
              粉丝画像 <i class="el-icon-arrow-down"></i>
            </div>
          </el-popover>
          <el-popover class="info_option" placement="bottom" trigger="click" v-model="visible_watcher">
            <div class="fans_img_2">
              <div class="box">
                <div class="name_1">观众年龄</div>
                <el-select v-model="watcher.watcher_age_rate_most" multiple collapse-tags placeholder="请选择">
                  <el-option v-for="item in ages" :key="item.label" :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="box">
                <div class="name_1">观众性别</div>
                <el-select v-model="watcher.gender" placeholder="请选择">
                  <el-option v-for="item in genders" :key="item.label" :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="box">
                <div class="name_1">观众设备品牌</div>
                <el-select v-model="watcher.watcher_system_rate_most" multiple collapse-tags placeholder="请选择">
                  <el-option v-for="item in systems" :key="item.label" :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="box">
                <div class="name_1">观众地域</div>
                <el-select v-model="watcher.watcher_city_level_most" multiple collapse-tags placeholder="请选择">
                  <el-option v-for="item in cities" :key="item.label" :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="double_btn">
                <button class="btn_1" @click="resetSingle('watcher')">重置</button>
                <button class="btn_3" @click="visible_watcher = false">取消</button>
                <button class="btn_2" @click="confirm('watcher')">确定</button>
              </div>
            </div>
            <div slot="reference" class="option_text">
              观众画像 <i class="el-icon-arrow-down"></i>
            </div>
          </el-popover>
          <el-popover class="info_option" placement="bottom" trigger="click" v-model="visible_fans_club">
            <div class="fans_img_2">
              <div class="box">
                <div class="name_1">粉丝团年龄</div>
                <el-select v-model="fans_club.fans_club_age_rate_most" multiple collapse-tags placeholder="请选择">
                  <el-option v-for="item in ages" :key="item.label" :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="box">
                <div class="name_1">粉丝团性别</div>
                <el-select v-model="fans_club.gender" placeholder="请选择">
                  <el-option v-for="item in genders" :key="item.label" :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="box">
                <div class="name_1">粉丝团设备品牌</div>
                <el-select v-model="fans_club.fans_club_system_rate_most" multiple collapse-tags placeholder="请选择">
                  <el-option v-for="item in systems" :key="item.label" :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="box">
                <div class="name_1">粉丝团地域</div>
                <el-select v-model="fans_club.fans_club_city_level_most" multiple collapse-tags placeholder="请选择">
                  <el-option v-for="item in cities" :key="item.label" :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="double_btn">
                <button class="btn_1" @click="resetSingle('fans_club')">重置</button>
                <button class="btn_3" @click="visible_fans_club = false">取消</button>
                <button class="btn_2" @click="confirm('fans_club')">确定</button>
              </div>
            </div>
            <div slot="reference" class="option_text">
              粉丝团画像 <i class="el-icon-arrow-down"></i>
            </div>
          </el-popover>
        </div>
      </div>
      <!-- ======================= 品牌传播 ====================== -->
      <div v-if="marketing_target===1">
        <div class="item">
          <span class="des">适合行业</span>
          <div class="single">
            <div :class="open ? 'options_open' : 'options_close'" class="options">
              <el-checkbox class="pop2" @change="handleCheckboxLevel('适合行业', $event, '不限')"
                v-model="industryIsNoLimit">不限</el-checkbox>
              <template v-for="(item, index) in filterOption.industry">
                <el-popover v-if="item.children.length" :class="item.childrenChecked.length ? item.childrenChecked.length === item.children.length ? 'pop2' : 'pop3' : 'pop2'"
                  :key="index" placement="bottom" trigger="hover">
                  <div class="sub_list">
                    <template v-if="item.children.length">
                      <el-checkbox class="sub_item" v-for="(sebItem,subIndex) of item.children"
                      v-model="sebItem.check"
                      :key="subIndex"
                      @change="handleCheckboxLevel('适合行业', $event, index, subIndex)">{{sebItem.name}}</el-checkbox>
                    </template>
                    <span v-else>无</span>
                  </div>
                  <div slot="reference">
                    <el-checkbox @change="handleCheckboxLevel('适合行业', $event, index)"
                      v-model="item.check">{{item.name}}</el-checkbox>
                  </div>
                </el-popover>
                <el-checkbox v-else class="my-checked" :key="index" @change="handleCheckboxLevel('适合行业', $event, index)"
                      v-model="item.check">{{item.name}}</el-checkbox>
              </template>
            </div>
            <div class="open_close" @click="open = !open">
              {{ open ? "收起" : "展开" }}
              <i :class="open ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
            </div>
          </div>
        </div>
        <div class="item">
          <span class="des">传播效果</span>
          <div class="options">
            <el-popover class="info_option" placement="bottom" trigger="click"
              v-for="(item, index) of spreadOptionText" :key="index" v-model="item.visible">
              <div class="fans_price">
                <div v-for="(option, index1) of item.options" :key="index1" class="son_option"
                  @click="choice(option, item)">
                  {{ option.label }}
                </div>
                <div class="to_input" v-if="['预期观看人数', '互动率'].includes(item.name)">
                  <el-input v-model="item.start" placeholder="请输入"></el-input>
                  <i v-if="item.name === '互动率'">%</i>
                  <div class="short_line"></div>
                  <el-input v-model="item.end" placeholder="请输入"></el-input>
                  <i v-if="item.name === '互动率'">%</i>
                </div>
                <div class="double_btn" v-if="['预期观看人数', '互动率'].includes(item.name)">
                  <button class="btn_1" @click="resetDes('spreadOptionText', index)">重置</button>
                  <button class="btn_2" @click="desConfirm(item)">确定</button>
                </div>
              </div>
              <div slot="reference" class="option_text">
                {{ item.value }} <i class="el-icon-arrow-down"></i>
              </div>
            </el-popover>
          </div>
        </div>
      </div>
      <!-- ======================= 品牌传播 ====================== -->
      <!-- ======================= 电商卖货 ====================== -->
      <div v-if="marketing_target===2">
        <div class="item" style="margin-top:20px;">
          <span class="des">带货品类</span>
          <div :class="open_2 ? 'options_open' : 'options_close'" class="options">
            <el-checkbox-group v-model="main_category"
              @change="addTags($event, {type: '带货品类', key: 'main_category'})">
              <el-checkbox class="pop4" label="不限">不限</el-checkbox>
              <el-checkbox class="pop4" v-for="(item, index) of queryInfo.main_category" :key="index"
                :label="item">{{
                item
              }}</el-checkbox>
            </el-checkbox-group>
          </div>
          <div class="open_close" @click="open_2 = !open_2">
            {{ open_2 ? "收起" : "展开" }}
            <i :class="open_2 ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          </div>
        </div>
        <div class="item">
          <span class="des">带货效果</span>
          <div class="options">

            <el-popover class="info_option" placement="bottom" trigger="click"
              v-for="(item, index) of ecomSpreadOptionText" :key="index" v-model="item.visible">
              <div class="fans_price">
                <div v-for="(option, index1) of item.options" :key="index1" class="son_option"
                  @click="choice(option, item)">
                  {{ option.label }}
                </div>
                <template v-if="['平均销售额', '带货商品价格', 'GPM'].includes(item.name)">
                  <div class="to_input">
                    <el-input v-model="item.start" placeholder="请输入"></el-input>
                    <div class="short_line"></div>
                    <el-input v-model="item.end" placeholder="请输入"></el-input>
                  </div>
                  <div class="double_btn">
                    <button class="btn_1" @click="resetDes('ecomSpreadOptionText', index)">重置</button>
                    <button class="btn_2" @click="desConfirm(item)">确定</button>
                  </div>
                </template>
              </div>
              <div slot="reference" class="option_text">
                {{ item.value }} <i class="el-icon-arrow-down"></i>
              </div>
            </el-popover>
          </div>
        </div>
      </div>
      <!-- ======================= 电商卖货 ====================== -->
      <!-- ======================= 游戏下载 ====================== -->
      <div v-if="marketing_target===3">
        <div class="item">
          <span class="des">游戏玩法</span>
          <div :class="open_1 ? 'options_open' : 'options_close'" class="options">
            <el-checkbox-group v-model="live_game_category"
              @change="addTags($event, {type: '游戏玩法', key: 'live_game_category'})">
              <el-checkbox class="pop4" label="不限">不限</el-checkbox>
              <el-checkbox class="pop4" v-for="(item, index) of queryInfo.live_game_category" :key="index"
                :label="item">{{
                item
              }}</el-checkbox>
            </el-checkbox-group>
          </div>
          <div class="open_close" @click="open_1 = !open_1">
            {{ open_1 ? "收起" : "展开" }}
            <i :class="open_1 ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          </div>
        </div>

        <div class="item">
          <span class="des">游戏题材</span>
          <div :class="gameThemeSlide ? 'options_open' : 'options_close'" class="options">
            <el-checkbox-group v-model="live_game_theme"
              @change="addTags($event, {type: '游戏题材', key: 'live_game_theme'})">
              <el-checkbox class="pop4" label="不限">不限</el-checkbox>
              <el-checkbox class="pop4" v-for="(item, index) of queryInfo.live_game_theme" :key="index"
                :label="item">{{
                item
              }}</el-checkbox>
            </el-checkbox-group>
          </div>
          <div class="open_close" @click="gameThemeSlide = !gameThemeSlide">
            {{ gameThemeSlide ? "收起" : "展开" }}
            <i :class="gameThemeSlide ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          </div>
        </div>

        <div class="item">
          <span class="des">转化效果</span>
          <div class="options">

            <el-popover class="info_option" placement="bottom" trigger="click"
              v-for="(item, index) of gameSpreadOptionText" :key="index" v-model="item.visible">
              <div class="ecom">
                <div class="option_show" v-for="(option, index2) of item.options" :key="index2"
                  @click="choice(option, item)">
                  {{ option.label }}
                </div>
              </div>
              <div class="to_input">
                  <el-input v-model="item.start" placeholder="请输入"></el-input>
                  <div class="short_line"></div>
                  <el-input v-model="item.end" placeholder="请输入"></el-input>
                </div>
                <div class="double_btn">
                  <button class="btn_1" @click="resetDes('gameSpreadOptionText', index)">重置</button>
                  <button class="btn_2" @click="desConfirm(item)">确定</button>
                </div>
              <div slot="reference" class="option_text">
                {{ item.value }} <i class="el-icon-arrow-down"></i>
              </div>
            </el-popover>
           
          </div>
        </div>
        
      </div>
      <!-- ======================= 游戏下载 ====================== -->
      <div class="item">
        <span class="des">其他筛选</span>
        <div class="options">
          <el-checkbox v-model="query.hz" @change="switchChecked($event, {
            name: '已入库达人',
            key: 'hz'
          })" :disabled='inSalesGroup'>
            已入库达人
            <el-tooltip effect="dark" content="已入库达人：已入我司媒体库的达人。" placement="bottom">
              <img src="../../../assets/question.png" class="question" alt="">
            </el-tooltip>
          </el-checkbox>

          <el-checkbox v-model="query.tcount" @change="switchChecked($event, {name: '已合作达人', key: 'tcount'})" :disabled='inSalesGroup'>
            已合作达人
            <el-tooltip effect="dark" content="已合作达人：已入我司媒体库且与我司有合作记录的达人。" placement="bottom">
              <img src="../../../assets/question.png" class="question" alt="">
            </el-tooltip>
          </el-checkbox>
          <el-checkbox v-model="query.mcn" @change="switchChecked($event, {name: '已签约达人', key: 'mcn'})" :disabled='inSalesGroup'>
            已签约达人
            <el-tooltip effect="dark" content="已签约达人：mcn机构为畅玩文化的达人。" placement="bottom">
              <img src="../../../assets/question.png" class="question" alt="">
            </el-tooltip>
          </el-checkbox>
          <el-popover class="info_option" placement="bottom" trigger="click" v-model="devidedrate_ge_popover" style="margin-left:30px;">
            <div class="fans_price">
              <div v-for="(option, index1) of devidedrate_ge" :key="index1" class="son_option" @click="chooseBtn(option)">
                {{option.label}}
              </div>
            </div>
            <div slot="reference" class="option_text">
              返点比例
              <el-tooltip effect="dark" content="合作达人勾选情况下有效" placement="bottom">
                <img src="../../../assets/question.png" class="question" alt="">
              </el-tooltip>
              <i class="el-icon-arrow-down"></i>
            </div>
          </el-popover>
          <el-popover class="info_option" placement="bottom" trigger="click" v-model="recent_live_content_popover" style="margin-left:30px;">
            <div class="fans_price">
              <div v-for="(option, index1) of recent_live_content" :key="index1" class="son_option" @click="chooseRecentLiveContent(option)">
                {{option.value}}
              </div>
            </div>
            <div slot="reference" class="option_text">
              近期直播内容
              <i class="el-icon-arrow-down"></i>
            </div>
          </el-popover>

        </div>
      </div>
      <div class="line"></div>
      <div class="item">
        <span class="des">已选</span>
        <div class="options">
          <el-tag v-for="(tag, index) in tags" :key="index" closable type="info" size="small" @close="deleteTag(tag, index)">
            {{`${tag.type ? tag.type + '：' : ''}${tag.name}`}}
          </el-tag>
        </div>
        <div class="open_close" @click="delAllTag">清空 <i class="el-icon-delete"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props:[],
    data() {
      return {
        areachose:[],
        search: "",
        searchHistory: [],
        radio: 1,
        radio1: "1",
        open: false,
        open_1: false,
        open_2: false,
        gameThemeSlide: false,
        start: '',
        end: '',
        visible: false,
        visible_fans: false,
        visible_watcher: false,
        visible_fans_club: false,
        visible_2: false,
        visible_3: false,
        value: '',
        checkList: [],
        isSingle: true,
        checked: false,
        searchVisible: false,
        queryInfo: {},
        infoOptionText: {
          fans: {
            name: "粉丝数量",
            value: "粉丝数量",
            actualValue: {
              fans_max: '',
              fans_min: '',
            },
            options: [],
            start: '',
            end: '',
            visible: false
          },
          price: {
            name: "达人报价",
            value: "达人报价",
            actualValue: {
              price_max: '',
              price_min: '',
            },
            options: [],
            start: '',
            end: '',
            visible: false
          },
          area: {
            name: "所在地域",
            value: "所在地域",
            options: [],
            visible: false,
            curArr:{}
          },
          sex: {
            name: "达人性别",
            value: "达人性别",
            visible: false,
            options: [],
          },
          // styleTag: {
          //   name: "风格标签",
          //   value: "风格标签",
          //   visible: false,
          //   options: [],
          // },
        },
        // 品牌传播下的传播效果（手动添加的配置，没有从接口中获取）
        spreadOptionText: {
          watch: {
            name: "预期观看人数",
            value: "预期观看人数",
            actualValue: {
              live_expected_play_num__ge: '',
              live_expected_play_num__le: '',
            },
            options: [
              {label: '全部'},
              {live_expected_play_num__ge: 500000, label: '50w以上'},
              {live_expected_play_num__ge: 200000, live_expected_play_num__le: 500000, label: '20-50w'},
              {live_expected_play_num__ge: 100000, live_expected_play_num__le: 200000, label: '10-20w'},
              {live_expected_play_num__ge: 50000, live_expected_play_num__le: 100000, label: '5-10w'},
              {live_expected_play_num__ge: 10000, live_expected_play_num__le: 50000, label: '1-5w'},
              {live_expected_play_num__le: 10000, label: '1w以下'},
            ],
            visible: false,
            start: '',
            end: '',
          },
          interactiveRate: {
            name: "互动率",
            value: "互动率",
            actualValue: {
              live_interaction_rate_medium_30d__ge: '',
              live_interaction_rate_medium_30d__le: '',
            },
            options: [
              {label: '全部'},
              {live_interaction_rate_medium_30d__ge:1, label: '1%以上'},
              {live_interaction_rate_medium_30d__ge:2, label: '2%以上'},
              {live_interaction_rate_medium_30d__ge:3, label: '3%以上'},
              {live_interaction_rate_medium_30d__ge:4, label: '4%以上'},
              {live_interaction_rate_medium_30d__ge:5, label: '5%以上'},
            ],
            visible: false,
            start: '',
            end: '',
          },
          averageWatchTime: {
            name: "平均观看时长",
            value: "平均观看时长",
            actualValue: {
              live_avg_watch_duration_30d__ge: '',
              live_avg_watch_duration_30d__le: '',
            },
            options: [
              {label: '全部'},
              {live_avg_watch_duration_30d__le:60, label: '1分钟以下'},
              {live_avg_watch_duration_30d__ge:60,live_avg_watch_duration_30d__le:300, label: '1-5分钟'},
              {live_avg_watch_duration_30d__ge:300,live_avg_watch_duration_30d__le:600, label: '5-10分钟'},
              {live_avg_watch_duration_30d__ge:600, label: '10分钟以上'}
            ],
            visible: false,
            start: '',
            end: '',
          },
          averageLiveTime: {
            name: "平均直播时长",
            value: "平均直播时长",
            actualValue: {
              live_duration_avg_30d__le: '',
              live_duration_avg_30d__le: '',
            },
            options: [
              {label: '全部'},
              {live_duration_avg_30d__le:3600, label: '1小时以下'},
              {live_duration_avg_30d__ge:3600,live_duration_avg_30d__le:10800, label: '1-3小时'},
              {live_duration_avg_30d__ge:10800,live_duration_avg_30d__le:18000, label: '3-5小时'},
              {live_duration_avg_30d__ge:18000, label: '5小时以上'},
            ],
            visible: false,
            start: '',
            end: '',
          }
        },
        // 带货效果
        ecomSpreadOptionText: { //电商带货
          averageWatchTime: {
            name: "平均观看时长",
            value: "平均观看时长",
            actualValue: {
              live_avg_watch_duration_30d__ge: '',
              live_avg_watch_duration_30d__le: '',
            },
            options: [
              {label: '全部'},
              {live_avg_watch_duration_30d__le:60, label: '1分钟以下'},
              {live_avg_watch_duration_30d__ge:60,live_avg_watch_duration_30d__le:300, label: '1-5分钟'},
              {live_avg_watch_duration_30d__ge:300,live_avg_watch_duration_30d__le:600, label: '5-10分钟'},
              {live_avg_watch_duration_30d__ge:600, label: '10分钟以上'}
            ],
            visible: false,
            start: '',
            end: '',
          },
          saleNum: {
            name: "带货商品数",
            value: "带货商品数",
            actualValue: {
              ecom_live_product_num__ge: '',
              ecom_live_product_num__le: '',
            },
            options: [
              {label: '全部'},
              {ecom_live_product_num__ge:0,ecom_live_product_num__le:10, label: '0-10'},
              {ecom_live_product_num__ge:10,ecom_live_product_num__le:20, label: '10-20'},
              {ecom_live_product_num__ge:20,ecom_live_product_num__le:40, label: '20-40'},
              {ecom_live_product_num__ge:40,ecom_live_product_num__le:80, label: '40-80'},
              {ecom_live_product_num__ge:80, label: '80以上'},
            ],
            visible: false,
            start: '',
            end: '',
          },
          saleAmount: {
            name: "平均销售额",
            value: "平均销售额",
            actualValue: {
              avg_sale_amount__ge: '',
              avg_sale_amount__le: '',
            },
            options: [
            ],
            visible: false,
            start: '',
            end: '',
          },
          main_price_30d: {
            name: "带货商品价格",
            value: "带货商品价格",
            actualValue: {
              ecom_main_price_30days__ge: '',
              ecom_main_price_30days__le: ''
            },
            options: [],
            visible: false,
            start: '',
            end: '',
          },
          ecomScore: {
            name: "带货口碑",
            value: "带货口碑",
            actualValue: {
              ecom_score__ge: ''
            },
            options: [
              {label: '全部'},
              {ecom_score__ge: 4.8, label: '>4.8'},
              {ecom_score__ge: 4.5, label: '>4.5'},
              {ecom_score__ge: 4.3, label: '>4.3'},
              {ecom_score__ge: 4.0, label: '>4.0'}
            ],
            visible: false,
          },
          GPM: {
            name: "GPM",
            value: "GPM",
            actualValue: {
              ecom_gpm_30days__ge: '',
              ecom_gpm_30days__le: '',
            },
            options: [],
            visible: false,
            start: '',
            end: '',
          },
        },
        // 游戏转化效果
        gameSpreadOptionText: {
          gameCPC: {
            name: "游戏CPC",
            value: "游戏CPC",
            actualValue:{
              median_game_item_cpc_90_days__le: '',
              median_game_item_cpc_90_days__ge: ''
            },
            options: [
              {label: '全部'},
              {
                median_game_item_cpc_90_days__le: 4, label: '4以下'
              },
              {
                median_game_item_cpc_90_days__le: 6,
                median_game_item_cpc_90_days__ge: 4, label: '4-6'
              },
              {
                median_game_item_cpc_90_days__le: 10,
                median_game_item_cpc_90_days__ge: 6, label: '6-10'
              },
              {
                median_game_item_cpc_90_days__le: 20,
                median_game_item_cpc_90_days__ge: 10, label: '10-20'
              },
              {
                median_game_item_cpc_90_days__le: 40,
                median_game_item_cpc_90_days__ge: 20, label: '20-40'
              },
              {
                median_game_item_cpc_90_days__ge: 40, label: '40以上'
              }
            ],
            visible: false,
            start: '',
            end: '',
          },
          componentClick: {
            name: "组件点击量",
            value: "组件点击量",
            actualValue: {
              median_game_item_component_click_90_days__le: '',
              median_game_item_component_click_90_days__ge: ''
            },
            options: [
              {
                median_game_item_component_click_90_days__le: 500
              },
              {
                median_game_item_component_click_90_days__le: 1000,
                median_game_item_component_click_90_days__ge: 500
              },
              {
                median_game_item_component_click_90_days__le: 3000,
                median_game_item_component_click_90_days__ge: 1000
              },
              {
                median_game_item_component_click_90_days__le: 5000,
                median_game_item_component_click_90_days__ge: 3000
              },
              {
                median_game_item_component_click_90_days__le: 10000,
                median_game_item_component_click_90_days__ge: 5000
              },
              {
                median_game_item_component_click_90_days__le: 30000,
                median_game_item_component_click_90_days__ge: 10000
              },
              {
                median_game_item_component_click_90_days__le: 50000,
                median_game_item_component_click_90_days__ge: 30000
              },
              {
                median_game_item_component_click_90_days__le: 100000,
                median_game_item_component_click_90_days__ge: 50000
              },
              {
                median_game_item_component_click_90_days__le: 200000,
                median_game_item_component_click_90_days__ge: 100000
              },
              {
                median_game_item_component_click_90_days__ge: 200000
              }
            ],
            visible: false,
            start: '',
            end: '',
          },
          watch: {
            name: "预期观看人数",
            value: "预期观看人数",
            actualValue: {
              live_expected_play_num__ge: '',
              live_expected_play_num__le: '',
            },
            options: [
              {label: '全部'},
              {live_expected_play_num__ge: 500000, label: '50w以上'},
              {live_expected_play_num__ge: 200000, live_expected_play_num__le: 500000, label: '20-50w'},
              {live_expected_play_num__ge: 100000, live_expected_play_num__le: 200000, label: '10-20w'},
              {live_expected_play_num__ge: 50000, live_expected_play_num__le: 100000, label: '5-10w'},
              {live_expected_play_num__ge: 10000, live_expected_play_num__le: 50000, label: '1-5w'},
              {live_expected_play_num__le: 10000, label: '1w以下'},
            ],
            visible: false,
            start: '',
            end: '',
          },
          interactiveRate: {
            name: "互动率",
            value: "互动率",
            actualValue: {
              live_interaction_rate_medium_30d__ge: '',
              live_interaction_rate_medium_30d__le: '',
            },
            options: [
              {label: '全部'},
              {live_interaction_rate_medium_30d__ge:1, label: '1%以上'},
              {live_interaction_rate_medium_30d__ge:2, label: '2%以上'},
              {live_interaction_rate_medium_30d__ge:3, label: '3%以上'},
              {live_interaction_rate_medium_30d__ge:4, label: '4%以上'},
              {live_interaction_rate_medium_30d__ge:5, label: '5%以上'},
            ],
            visible: false,
            start: '',
            end: '',
          },
        },
        
        // tags: [],
        tags: [{name: '已入库达人', value: true, key: 'hz'}],
        //#region   受众画像
        ages: [
          {
            label: '18-23岁居多',
            value: '21'
          }, {
            label: '24-30岁居多',
            value: '2'
          }, {
            label: '31-40岁居多',
            value: '23'
          }, {
            label: '41-50岁居多',
            value: '24'
          }, {
            label: '50以上',
            value: '25'
          }
        ],
        genders: [{
            label: '全部',
            value: ''
          }, {
            label: '男性占比大于50%',
            value: 'gender_male_rate__ge=50'
          },{
            label: '男性占比大于60%',
            value: 'gender_male_rate__ge=60'
          }, {
            label: '男性占比大于70%',
            value: 'gender_male_rate__ge=70'
          },{
            label: '男性占比大于80%',
            value: 'gender_male_rate__ge=80'
          },{
            label: '女性占比大于50%',
            value: 'gender_female_rate__ge=50'
          },{
            label: '女性占比大于60%',
            value: 'gender_female_rate__ge=60'
          },{
            label: '女性占比大于70%',
            value: 'gender_female_rate__ge=70'
          },{
            label: '女性占比大于80%',
            value: 'gender_female_rate__ge=80'
          }
        ],
        systems: [
          {
            label: '苹果居多',
            value: '10'
          }, {
            label: '华为居多',
            value: '26'
          }, {
            label: '小米居多',
            value: '27'
          }, {
            label: 'VIVO居多',
            value: '28'
          }, {
            label: 'OPPO居多',
            value: '29'
          }
        ],
        cities: [
          {
            label: '一线城市居多',
            value: '13'
          }, {
            label: '二线城市居多',
            value: '14'
          }, {
            label: '三线城市居多',
            value: '15'
          }, {
            label: '四线城市居多',
            value: '16'
          }, {
            label: '五线城市居多',
            value: '17'
          }
        ],
        fans: {
          name: '粉丝画像',
          keyMap: {
            fans_age_rate_most: '粉丝年龄',
            gender: '粉丝性别',
            fans_system_rate_most: '粉丝设备品牌',
            fans_city_level_most: '粉丝地域'
          },
          fans_age_rate_most: [],
          gender: '',
          fans_gender_male_rate__ge: '',
          fans_gender_female_rate__ge: '',
          fans_system_rate_most: [],
          fans_city_level_most: []
        },
        watcher: {
          name: '观众画像',
          keyMap: {
            watcher_age_rate_most: '观众年龄',
            gender: '观众性别',
            watcher_system_rate_most: '观众设备品牌',
            watcher_city_level_most: '观众地域'
          },
          watcher_age_rate_most: [],
          gender: '',
          watcher_gender_male_rate__ge: '',
          watcher_gender_female_rate__ge: '',
          watcher_system_rate_most: [],
          watcher_city_level_most: []
        },
        fans_club: {
          name: '粉丝团画像',
          keyMap: {
            fans_club_age_rate_most: '粉丝团年龄',
            gender: '粉丝团性别',
            fans_club_system_rate_most: '粉丝团设备品牌',
            fans_club_city_level_most: '粉丝团地域'
          },
          fans_club_age_rate_most: [],
          gender: '',
          fans_club_gender_male_rate__ge: '',
          fans_club_gender_female_rate__ge: '',
          fans_club_system_rate_most: [],
          fans_club_city_level_most: []
        },
        //#endregion
        //#region   返点比例
        devidedrate_ge_popover: false,
        devidedrate_ge:[{ // 返点比例
          label: '全部',
          value: ''
        },{
          label: '20%以上',
          value: '20'
        },{
          label: '25%以上',
          value: '25'
        },{
          label: '30%以上',
          value: '30'
        }],
        //#endregion
        marketing_target: 1,  
        main_category: ['不限'],
        live_game_category: ['不限'],
        live_game_theme: ['不限'],
        query: {
          main_category: '',
          live_game_category: '',
          live_game_theme: '',
          tag: '',
          tag_level_two: '',
          fans_max: '',
          fans_min: '',
          price_max: '',
          price_min: '',
          province:'',
          city: '',
          gender: '',
          industry_tag_level_one: '',
          industry_tag_level_two: '',
          settlement_type: false,
          key: '',
          hz: true,
          tcount: false,
          mcn: false,
          devidedrate_ge:'',
          livecontent:"", //近期直播内容

        },
        inSalesGroup: false,


        // 内容类型和适合行业的选项数据
        filterOption: {
          content: [],
          industry: []
        },
        contentIsNoLimit: true,   // 内容类型是否为：不限
        industryIsNoLimit: true,   // 适合行业是否为：不限
        // 近期直播内容
        recent_live_content_popover :false,
        recent_live_content:[
          {value:"主机游戏"},
          {value:"射击（吃鸡类）"},
          {value:"街机格斗"},
          {value:"MMO"},
          {value:"MOBA"},
          {value:"休闲小游戏"},
          {value:"棋牌桌游"},
          {value:"其他游戏"},
          {value:"娱乐连麦"},
        ]
      }
    },
    created() {
      this.getQueryInfo(); //初始默认是品牌传播 6
      this.searchHistory = localStorage.getItem('searchHistory') ? localStorage.getItem('searchHistory').split(',') : []
      if (sessionStorage.getItem('inSalesGroup') === 'true') {
        this.query.hz = true
        this.inSalesGroup = true
      } else {
        this.inSalesGroup = false
        this.query.hz = true
      }
    },
    computed: {
      task_category(){
        return this.marketing_target === 2 ?  52 :  6
      },
    },
    watch: {
      tags: {
        handler(arr){
          let params = {}
          arr.forEach(x => {
            if(x.key instanceof Array){ // [{name: 'fans_max', value: 100000}]
              x.key.forEach(y => {
                params[y.name] = y.value
              })
            }else if(params[x.key]){
              params[x.key] += (',' + x.value)
            }else{
              params[x.key] = x.value
            }
          })
          this.query = {
            ...this.query,
            ...params,
          }
          this.commitParams()
        },
        deep: true
      },
    },
    methods: {
      commitParams(){
        this.query.task_category = this.task_category
        let {hz = '', tcount = '', mcn = '', settlement_type = ''} = this.query
        let params = {
          ...this.query,
          hz: hz ? 1 : '',
          tcount: tcount ? 1 : '',
          mcn: mcn ? 1 : '',
          settlement_type: settlement_type ? 1 : 0,
          key: this.search,
          marketing_target: this.marketing_target,
        }
        this.$emit('changeQuery',params);
      },
      addTags(arr, obj){
        let list = this.tags.filter(x => x.type !== obj.type)
        this.query[obj.type] = ''
        if(arr[arr.length - 1] === '不限' || !arr.length){
          arr = ['不限']
          this.tags = list
        }else{
          arr = arr.filter(x => x !== '不限')
          let tagList = []
          arr.forEach(x => {
            tagList.push({
              type: obj.type,
              name: x,
              key: obj.key,
              value: x
            })
          })
          this.tags = [...list, ...tagList]
        }
        this[obj.key] = arr
        



      },
      // 内容类型和适合行业筛选项处理
      handleCheckboxLevel(type, flag, index, subIndex){
        // console.log(flag, index, subIndex);
        let baseKey = 'content'
        let key1 = 'tag'
        let key2 = 'tag_level_two'
        
        if(type === '适合行业'){
          baseKey = 'industry'
          key1 = 'industry_tag_level_one'        
          key2 = 'industry_tag_level_two'
        }
        if(index === '不限'){
          this[baseKey + 'IsNoLimit'] = true
          this.filterOption[baseKey].forEach(x => {
            x.check = false
            x.childrenChecked = []
            x.children.forEach(y => {
              y.check = false
            })
          })
          this.tags = this.tags.filter(x => x.type !== type)
          return
        }
        this[baseKey + 'IsNoLimit'] = false
        if(subIndex !== undefined){
          this.filterOption[baseKey][index].children[subIndex].check = flag
        }else{
          this.filterOption[baseKey][index].check = flag
          this.filterOption[baseKey][index].children.forEach(x => x.check = flag)
        }

        let tags = []
        this.filterOption[baseKey].forEach(x => {
          let arr = x.children.filter(y => y.check).map(y => ({name: `${x.name}-${y.name}`, type, key: key2, value: y.value}))
          x.childrenChecked = arr
          if(!x.children.length){
            if(x.check){
              tags.push({name: `${x.name}-全部`, type, key: key1, value: x.value})
            }
          }else{
            if(!arr.length){
              x.check = false
            }else if(arr.length === x.children.length){
              x.check = true
              tags.push({name: `${x.name}-全部`, type, key: key1, value: x.value})
            }else{
              tags = [...tags, ...arr]
            }
          }
        })
        let list  = this.tags.filter(x => x.type !== type)
        this.tags = [...list, ...tags]
      },
      changeArea(arr){
        let provinces = []
        let cities = []
        arr.forEach(x => {
          provinces.push(x[0] || '')
          cities.push(x[1] || '')
        })
        provinces = Array.from(new Set(provinces))
        cities = Array.from(new Set(cities))
        let list = this.tags.filter(x => x.type !== '所在地域')
        if(cities.length){
          this.tags = [...list, {
            type: '所在地域',
            key: [
              {name: 'province', value: provinces.join()},
              {name: 'city', value: cities.join()},
            ],
            name: `共${cities.length}项`,
          }]
        }else{
          this.tags = list
        }

      },
      
      // 根据字段中是否包含min/ge或者max/le返回对象中对应的最大最小字段
      getMinMaxKey(obj, type = 'min'){
        let keys = Object.keys(obj)
        if(type === 'min'){
          return keys.find(x => x.includes('_min') || x.includes('_ge')) || ''
        }else{
          return keys.find(x => {
            if(x.includes('_max') || x.includes('_le')){
              return x
            }
          }) || ''
        }
      },
      handleRangeLabel(item, obj = null){
        // obj用于改变返回的list中对象键的名称，返回的键名不能直接使用时更换
        let list = item.map(x => {
          let extTxt = ''
          let startUnit = ''
          let endUnit = ''
          let start = ''
          let end = ''
          let keys = Object.keys(x)

          let minKey = this.getMinMaxKey(x)
          let maxKey = this.getMinMaxKey(x, 'max')
          // 键名中含有price amount  num  fans gpm click的视为需要进行 万/亿  的数值处理
          if(keys[0].includes('price') || keys[0].includes('amount')
           || keys[0].includes('num') || keys[0].includes('fans') || keys[0].includes('gpm')
           || keys[0].includes('click')
           ){
            start = minKey ? x[minKey] >= 100000000 ? x[minKey] / 100000000 : 
              x[minKey] >= 10000 ? x[minKey] / 10000 : x[minKey] : ''
            startUnit = x[minKey] >= 100000000 ? '亿' : x[minKey] >= 10000 ? 'w' : ''

            end = maxKey ? x[maxKey] >= 100000000 ? x[maxKey] / 100000000 : 
              x[maxKey] >= 10000 ? x[maxKey] / 10000 : x[maxKey] : ''
            endUnit = x[maxKey] >= 100000000 ? '亿' : x[maxKey] >= 10000 ? 'w' : ''
          }
          if(keys.length === 1){
            if(keys[0].includes('_min') || keys[0].includes('_ge')){ 
              extTxt = '以上'
            }
            if(keys[0].includes('_max') || keys[0].includes('_le')){
              extTxt = '以下'
            }
          }
          x.label = start + startUnit + `${keys.length == 2 ? '-' : ''}` + end + endUnit + extTxt
          return {...x}
        })
        list.unshift({label: '全部'})
        if(obj){
          return list.map(x => {
            for (let k in obj) {
              if(x.hasOwnProperty(k)){
                x[obj[k]] = x[k]
                delete x[k]
              }
            }
            return x
          })
        }else{
          return list
        }
        
      },
      async getQueryInfo() {
        await this.$api.getData.getQueryInfo(`task_category=${this.task_category}`).then((res) => {
          if (res.data.code === 0) {
            this.queryInfo = res.data.data
            console.log('res.data.data :>> ', res.data.data);
            this.queryInfo.tag = this.queryInfo.tag.map(t => {
              t.first = this.formatData(t.first)
              t.second = t.second.map(y => {
                return this.formatData(y)
              })
              return t
            })
            let marketing_target=[{value: 1, key: "品牌传播"}, {value: 2, key: "电商卖货"},{value: 3, key: "游戏下载"}]
            this.queryInfo.marketing_target=marketing_target
            this.infoOptionText.price.options = this.handleRangeLabel(this.queryInfo.price)
            this.infoOptionText.fans.options = this.handleRangeLabel(this.queryInfo.fans)
            this.infoOptionText.area.options = this.areaFormat(this.queryInfo.location)
            this.infoOptionText.sex.options = this.queryInfo.gender.map(t => {
              return {
                id: t[0],
                value: t[1]
              }
            })
            this.infoOptionText.sex.options.unshift({
              id: 0,
              value: '全部'
            })
            

            this.gameSpreadOptionText.watch.options = this.queryInfo.expected_play_num
            // 平均销售额
            this.ecomSpreadOptionText.saleAmount.options = this.handleRangeLabel(this.queryInfo.avg_sale_amount)
            // 带货商品价格
            this.ecomSpreadOptionText.main_price_30d.options = this.handleRangeLabel(this.queryInfo.main_price_30d, {
              main_price_30d_max__le: 'ecom_main_price_30days__le',
              main_price_30d_min__ge: 'ecom_main_price_30days__ge'
            })
            this.ecomSpreadOptionText.GPM.options = this.handleRangeLabel(this.queryInfo.author_gpm, {
              author_gpm__ge: 'ecom_gpm_30days__ge',
              author_gpm__le: 'ecom_gpm_30days__le',
            })
            this.gameSpreadOptionText.componentClick.options = this.handleRangeLabel(this.gameSpreadOptionText.componentClick.options)



            let list = []
            // 内容类型筛选项配置
            this.queryInfo.tag.forEach(function (item) {
              let obj = {
                name: item.first.value,
                value: item.first.id,
                check: false,
                childrenChecked: [],
                children: []
              }
              item.second.forEach(function (item) {
                obj.children.push({
                  name: item.value,
                  value: item.id,
                  check: false
                })
              })
              list.push(obj)
            })
            this.filterOption.content = list

            list = []
            // 适合行业筛选项配置
            this.queryInfo.industry_tag_v2.forEach(function (item) {
              let obj = {
                name: item.first[Object.keys(item.first)[0]],
                value: Object.keys(item.first)[0],
                check: false,
                childrenChecked: [],
                children: []
              }
              item.second.forEach(function (item) {
                for (const key in item) {
                  obj.children.push({
                    name: item[key],
                    value: key,
                    check: false
                  })
                }
                
              })
              list.push(obj)
            })
            this.filterOption.industry = list
            console.log('this.queryInfo ', this.queryInfo);
          }
          let areaArr = {}
          this.infoOptionText.area.options.map((item,i)=>{
            areaArr[item.label]={
              childNum : item.children.length,
              current:[]
            }
          })
          this.infoOptionText.area.curArr = areaArr
        })
      },
      formatData(data) {
        for (let item in data) {
          data = {
            id: item,
            value: data[item],
            visible: false
          }
        }
        return data;
      },
      areaFormat(data) {
        let arealist = []
        for (let item in data) {
          arealist.push({
            label: item,
            value: item,
            children: data[item].map(t => {
              return {
                label: t,
                value: t,
              }
            })
          })
        }
        return arealist
      },
      // 选项值处理
      choice(value, item) {
        // console.log(value, item);
        item.visible = false;
        item.start = item.end = ''
        item.value = value.label || ''
        let list = this.tags.filter(x => x.type !== item.name)
        let key = []
        Object.keys(item.actualValue).forEach(x => {
          key.push({
            name: x,
            value: value[x] || ''
          })
        })
        this.tags = [...list, {
          type: item.name,
          name: value.label,
          key
        }]
      },
      //选项弹窗中的输入确定   达人性别选择
      desConfirm(item, option) {
        // console.log(item)
        item.visible = false
        if(item.name === '达人性别'){
          let list = this.tags.filter(x => x.type !== '达人性别')
          if(option.value === '全部'){
            this.tags = list
          }else{
            item.value = option.value
            this.tags = [...list, {
              type: '达人性别',
              name: option.value,
              key: 'gender',
              value: option.id
            }]
          }
          return
        }

        let minKey = this.getMinMaxKey(item.actualValue)
        let maxKey = this.getMinMaxKey(item.actualValue, 'max')
        this.choice({
          label: item.start + '-' + item.end,
          [minKey]: item.start,
          [maxKey]: item.end
        }, item)
      },
      //重置
      resetDes(mainKey, key) {
        this[mainKey][key].value = this[mainKey][key].name
        this[mainKey][key].start = ''
        this[mainKey][key].end = ''
        this[mainKey][key].visible = false
        this.tags = this.tags.filter(x => x.type !== this[mainKey][key].name)
      },
      resetSingle(type) {
        this.tags = this.tags.filter(x => x.type !== this[type].name)
        for (const key in this[type].keyMap) {
          this[type][key] = key === 'genders' ? '' : []
        }
        this.visible_fans = false
        this.visible_watcher = false
        this.visible_fans_club = false
      },
      confirm(type) {
        console.log('keyMap, this[type] :>> ', this[type]);
        let {keyMap = {}} = this[type]

        let list = this.tags.filter(x => x.type !== this[type].name)
        let tagList = []
        for (const key in keyMap) {
          if(key === 'gender'){
            if(!this[type].gender){continue}
            // 确定保存男女性别的字段名称
            let femaleKey = Object.keys(this[type]).find(x => x.includes('gender_female'))
            let maleKey = Object.keys(this[type]).find(x => x.includes('gender_male'))
            let cur = this.genders.find(x => x.value === this[type].gender)
            let genderKey = cur.value.split('=')[0].includes('gender_female') ? femaleKey : maleKey
            tagList.push({
              type: this[type].name,
              name: `${keyMap[key]}-${cur.label || ''}`,
              key: genderKey,
              value: cur.value.split('=')[1]
            })
          }else{  // 年龄、设备品牌、地域   数组值处理
            // 确定下拉选项的字段名称，用于根据值确定该值对应的文本内容，进而显示在已选条件中
            let optionsKey = key.includes('gender') ? 'genders' : key.includes('age') ? 'ages' : key.includes('city') ? 'cities' : 'systems'
            // console.log('下拉选项字段名称：', key, optionsKey);
            this[type][key].forEach(x => {
              let cur = this[optionsKey].find(y => x === y.value) || {}
              tagList.push({
                type: this[type].name,
                name: `${keyMap[key]}-${cur.label || ''}`,
                key: key,
                value: x
              })
            })
          }
        } 
        this.tags = [...list, ...tagList]

        this.visible_fans = false
        this.visible_watcher = false
        this.visible_fans_club = false


      },
      chooseBtn(item){
        let list = this.tags.filter(x => x.type !== '返点比例')
        this.tags = [...list, {type: '返点比例', name: item.label, key: 'devidedrate_ge', value: item.value == 0 ? '' : item.value}]
        this.devidedrate_ge_popover = false
      },
      chooseRecentLiveContent(item){
        let list = this.tags.filter(x => x.type !== '近期直播内容')
        this.tags = [...list, {type: '近期直播内容', name: item.value, key: 'livecontent', value: item.value}]
        this.recent_live_content_popover = false
      },
      setTags(value, type, Industry, data) {  // data参数为后来添加的参数
        // console.log('value, type, Industry, 2222222222 :>> ', value, type, Industry, 2222222222);
        // console.log('this.tags :>> ', this.tags);
      },
      switchChecked(flag, obj){
        let list = this.tags.filter(x => x.name !== obj.name)
        if(flag){
          this.tags = [...list, {
            name: obj.name,
            key: obj.key,
            value: true
          }]
        }else{
          this.tags = list
        }
      },
      deleteTag(tag, index) {
        console.log('删除标签！！！！', tag);
        // 其他筛选项处理
        if(['hz', 'tcount', 'mcn','livecontent','devidedrate_ge'].includes(tag.key)){
          this.query[tag.key] = ''
        }


        // 清空粉丝画像、观众画像、粉丝团画像选中值
        if(tag.type && tag.type.includes('画像')){
          let portraitKey = tag.type === '粉丝画像' ? 'fans' : tag.type === '观众画像' ? 'watcher' : 'fans_club'
          if(tag.name.includes('性别')){
            this[portraitKey].gender = ''
          }else{
            this[portraitKey][tag.key] = this[portraitKey][tag.key].filter(x => x !== tag.value)
          }
          return
        }


        // 重置界面上筛选项的展示内容(涉及达人信息，传播效果，带货效果，转化效果)
        let inputKeys = ['infoOptionText', 'spreadOptionText', 'ecomSpreadOptionText', 'gameSpreadOptionText']
        inputKeys.every(x => {
          for (const key in this[x]) {
            if(this[x][key].name === tag.type){
              if(this[x][key].hasOwnProperty('start')){
                this[x][key].start = ''
              }
              if(this[x][key].hasOwnProperty('end')){
                this[x][key].end = ''
              }
              this[x][key].value = this[x][key].name
              return false
            }
          }
          return true
        })


        if(['带货品类', '游戏玩法', '游戏题材'].includes(tag.type)){
          let list = this[tag.key].filter(x => x !== tag.value)
          if(!list.length){
            this[tag.key] = ['不限']
            this.query[tag.key] = ''
          }else{
            this[tag.key] =  list
          }
        }

        if(tag.type == '所在地域'){
          this.areachose = []
        }


        this.tags.splice(index, 1)


      },
      delAllTag() {
        console.log('this.query :>> ', this.query);
        // this.tags = []
        this.tags = [{name: '已入库达人', value: true, key: 'hz'}]

        // 清空其他筛选项
        this.query.tcount = ''
        this.query.mcn = ''
        this.query.devidedrate_ge = ''
        this.query.livecontent = ''


        // 清空内容类型和适合行业筛选项
        this.contentIsNoLimit = true
        this.industryIsNoLimit = true
        for (const key in this.filterOption) {
          this.filterOption[key].forEach(x => {
            x.check = false
            x.childrenChecked = []
            x.children.forEach(y => y.check = false)
          })
        }


        // 清空粉丝画像、粉丝团画像、观众画像
        let portraitList = ['fans', 'watcher', 'fans_club']
        portraitList.forEach(x => {
          for (const key in this[x].keyMap) {
            this[x][key] = key === 'genders' ? '' : []
          }
        })
        
        // 清空手动输入框的值，恢复label显示
        let inputKeys = ['infoOptionText', 'spreadOptionText', 'ecomSpreadOptionText', 'gameSpreadOptionText']
        inputKeys.forEach(x => {
          for (const key in this[x]) {
            if(this[x][key].hasOwnProperty('start')){
              this[x][key].start = ''
            }
            if(this[x][key].hasOwnProperty('end')){
              this[x][key].end = ''
            }
            this[x][key].value = this[x][key].name
          }
        })
        
        this.areachose = [] // 清空所选地域

        // 清空'带货品类', '游戏玩法', '游戏题材'选中值
        let keys = ['main_category', 'live_game_category', 'live_game_theme']
        keys.forEach(x => {
          this.query[x] = ''
          this[x] = []
        })


      },
      searchBtn() {
        LA.track('dy_live_search');
        if (this.searchHistory.indexOf(this.search) === -1 && this.search !== '') {
          this.searchHistory.push(this.search)
        }
        if (this.searchHistory.length > 5) {
          this.searchHistory.shift()
        }
        localStorage.setItem('searchHistory', this.searchHistory.join(','))
        this.commitParams()
      },
      setSearch(note) {
        this.search = note
        this.searchBtn()
      },
      removeHistory() {
        localStorage.removeItem('searchHistory')
        this.searchHistory = []
      },
      async changeMarketingTarget() {
        this.query = {
          main_category: '',
          live_game_category: '',
          live_game_theme: '',
          tag: '',
          tag_level_two: '',
          fans_max: '',
          fans_min: '',
          price_max: '',
          price_min: '',
          province:'',
          city: '',
          gender: '',
          industry_tag_level_one: '',
          industry_tag_level_two: '',
          settlement_type: false,
          key: '',
          hz: false,
          tcount: false,
          mcn: false,
          devidedrate_ge:'',
        }
        this.delAllTag()
        await this.getQueryInfo()
        this.main_category = ['不限']
        this.live_game_category = ['不限']
        this.live_game_theme = ['不限']
        this.$emit('changeFatherMarketingTarget',this.marketing_target);
      },
      
    },
    mounted() {
    },
  };
</script>
<style scoped>
.area>>>.el-tag .el-icon-close{
  width: 0!important;
}

</style>

